import { Box, HStack, Select, Stack } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { AiFillCloseCircle, AiOutlineFieldNumber, AiOutlineSearch } from 'react-icons/ai'
import { FaUserAlt } from 'react-icons/fa'
import { SiQuantcast } from 'react-icons/si'
import { GetAllProductShelf, GetAllProductShelfWithoutDA, GetAllSuppliers } from '../Utils/ApiCalls'
import Input from './Input'
import { isEmergency } from '../Authetication'

export default function ProductCard({ Payload, setPayload, oldItem = [], data, i, }) {
    const [Data, setData] = useState([]);
    const [SearchText, setSearchText] = useState("");
    const [Switch, setSwitch] = useState(false);

    let itemToUpdate = oldItem;




    const handleShelfId = (e) => {
        //get the item index to update
        let objIndex = itemToUpdate.findIndex((obj, index) => index == i);

        // console.log("idd", objIndex, itemToUpdate[objIndex]);

        itemToUpdate[objIndex].shelfid = e.target.value

        setPayload({ ...Payload, product: itemToUpdate });
    }

    const handleQtyInspected = (e) => {
        //get the item index to update
        let objIndex = itemToUpdate.findIndex((obj, index) => index == i);

        // console.log("idd", objIndex, itemToUpdate[objIndex]);

        itemToUpdate[objIndex].qtyinspected = e.target.value

        setPayload({ ...Payload, product: itemToUpdate });
    }
    const handlePrice = (e) => {
        //get the item index to update
        let objIndex = itemToUpdate.findIndex((obj, index) => index == i);

        // console.log("idd", objIndex, itemToUpdate[objIndex]);

        itemToUpdate[objIndex].price = e.target.value

        setPayload({ ...Payload, product: itemToUpdate });
    }

    const removeItem = () => {
        let newItem = oldItem.filter((obj, index) => (
            index !== i
        ))

        setPayload({ ...Payload, product: newItem })
    }

    const GetAllShelf = async () => {
        let result = await GetAllProductShelfWithoutDA()

        console.log("result shelf", result);

        if (result.status == true) {
            isEmergency() ? (
                setData(result.queryresult.productshelfdetails.filter(item => item.store == Payload.store ))

            ):(
                setData(result.queryresult.productshelfdetails)

            )
        }
    }


    useEffect(() => {
        GetAllShelf()

    }, [Payload?.store]);

    return (
        <Stack spacing={"10px"}>
            <Box cursor={"pointer"} onClick={removeItem} display={i == 0 ? "none" : "flex"} justifyContent="flex-end"><AiFillCloseCircle /></Box>
            <hr className='hr' />
            {
                (Switch && data.shelfid == "" ) &&(

                    <Input leftIcon={<AiOutlineSearch />} iconColor="black" labelBg='#fff' label='search for shelfid' id="qtyinspected" type='text' value={SearchText} val={SearchText != "" ? true : false} onChange={(e) => setSearchText(e.target.value)} w="50%" />
                )
            }
            <HStack spacing={"10px"}>

                <Select onClick={() => setSwitch(true)} _focus={{ borderColor: "blue.blue400" }} placeholder='Select shelfId' fontWeight={"400"} fontSize={data.shelfid != "" ? "16px" : "12px"} id='shelfid' value={data.shelfid} onChange={handleShelfId}>
                    {

                        SearchText === "" ? (
                            Data.map((item, i) => (

                                <option key={i} value={`${item._id}`} >{item.productname}</option>
                            ))

                        ) : (

                            Data.filter(item => item.productname.toLocaleLowerCase().includes(SearchText.toLocaleLowerCase())).map((item, i) => (

                                <option  key={i}  value={`${item._id}`} >{item.productname}</option>
                            ))

                        )


                    }

                </Select>


                <Input leftIcon={<AiOutlineFieldNumber />} iconColor="black" labelBg='#fff' label='Quantity Inspected' id="qtyinspected" type='number' value={data.qtyinspected} val={data.qtyinspected != "" ? true : false} onChange={handleQtyInspected} />
            </HStack>

            <hr className='hr' />
        </Stack>
    )
}
